import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subject, BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../shared/shared.service';
import { ProductLostSubReasonService } from './product-lost-sub-reason.service';

@Component({
  selector: 'app-product-lost-sub-reason',
  templateUrl: './product-lost-sub-reason.component.html',
  styleUrls: ['./product-lost-sub-reason.component.scss']
})
export class ProductLostSubReasonComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'product_lost_reason', 'sub_reason', 'sub_reason_code', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  isLoading: Subject<boolean> = new Subject<boolean>();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  productLostSubReasonForm: FormGroup;
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private productLostSubReasonService: ProductLostSubReasonService) {
    this.productLostSubReasonForm = this.fb.group({
      sub_reason: ['', Validators.required],
      product_lost_reason_id: ['', Validators.required],
      sub_reason_code: [''],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getProductLostReasons();
  }

  get f() { return this.productLostSubReasonForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.productLostSubReasonForm.patchValue({
      sub_reason: object.sub_reason,
      sub_reason_code: object.sub_reason_code,
      product_lost_reason_id: object.product_lost_reason_id,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  create() {
    this.submitted = true
    if (this.productLostSubReasonForm.valid) {
      const reasonData = this.productLostSubReasonForm.value;
      let obj = {
        "sub_reason": reasonData.sub_reason,
        "sub_reason_code": reasonData.sub_reason_code,
        "product_lost_reason_id": parseInt(reasonData.product_lost_reason_id),
        "status": parseInt(reasonData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productLostSubReasonService.productLostSubReasonCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Product lost sub reason created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.productLostSubReasonForm.valid) {
      const reasonData = this.productLostSubReasonForm.value;
      let obj = {
        "sub_reason": reasonData.sub_reason,
        "sub_reason_code": reasonData.sub_reason_code,
        "product_lost_reason_id": parseInt(reasonData.product_lost_reason_id),
        "status": parseInt(reasonData.status),
        "flag": "update",
        "id": this.selectedObject.id
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productLostSubReasonService.productLostSubReasonCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Product lost sub reason updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.productLostSubReasonForm.patchValue({
      sub_reason: '',
      sub_reason_code: '',
      product_lost_reason_id: '',
      status: ''
    });
  }

  allowAlphabetsSplcharsOnly(event: any) {
    this.sharedService.allowAlphabetsSplcharsOnly(event);
  }

  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.productLostSubReasonService.productLostSubReasonCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  productLostReasons: any = []
  getProductLostReasons() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.productLostSubReasonService.getProductLostReasons(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.productLostReasons = responseData.data
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const reason = (data?.product_lost_reason?.reason || '').toLowerCase().includes(filter);
      const sub_reason = (data.sub_reason || '').toLowerCase().includes(filter);
      const code = (data.sub_reason_code || '').toLowerCase().includes(filter);
      return reason || sub_reason || code;
    };
    this.dataSource.filter = filterValue;
  }
  clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
